import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const Header = () => {
  return (
    <header className="bg-gray-900 sticky-top">
      <nav className="flex items-center">
        <Link to="/" className="logo flex items-center gap-4">
          <img src={logo} width={50} alt="" />
          <span className="font-bold font-sacramento text-4xl">Study With Anis</span>
        </Link>
        <input type="checkbox" id="click" />
        <label htmlFor="click" className="menu-btn">
          <i className="fas fa-bars"></i>
        </label>
        <ul className="bg-gray-900">
          <li>
            <Link to="/">
              Home
            </Link>
          </li>
          <li>
            <Link to="/courses">Courses</Link>
          </li>
          <li>
            <Link to="/programming">Programming</Link>
          </li>
          <li>
            <Link to="/cse">Computer Science</Link>
          </li>
          <li>
            <Link to="/android">Android</Link>
          </li>
          <li>
            <Link to="/others">Others</Link>
          </li>
          <li>
            <Link to="/hsc">HSC ICT</Link>
          </li>
          <li>
            <Link to="/basic-computer">Basic Computer</Link>
          </li>
          
        </ul>
      </nav>
    </header>
  );
};

export default Header;
